import React from "react";
import styled from "styled-components";

// ✅ Correct imports
import Laptop3D from "../../assets/img/3dicons/laptop-3d.png";
import Globe3D from "../../assets/img/3dicons/globe-3d.png";
import Truck3D from "../../assets/img/3dicons/truck-3d.png";
import Handshake3D from "../../assets/img/3dicons/handshake-3d.png";

export default function Services() {
  return (
    <Wrapper id="services">
      <div className="whiteBg">
        <Container>
          <HeaderInfo>
            <h1>Our Services</h1>
            <p>
              Sama Al Falah delivers world-class distribution of laptops,
              desktops, and accessories. With reliable logistics, global reach,
              and strong supplier partnerships, we empower businesses to scale
              confidently worldwide.
            </p>
          </HeaderInfo>

          {/* Service 1 */}
          <ServiceItem>
            <IconWrapper>
              <div className="icon-rect green">
                <img src={Laptop3D} alt="Tech Distribution" />
              </div>
            </IconWrapper>
            <ServiceText>
              <h2>Tech Product Distribution</h2>
              <p>
                We specialize in distributing laptops, desktops, and accessories
                from leading global brands.
              </p>
            </ServiceText>
          </ServiceItem>

          {/* Service 2 */}
          <ServiceItem reverse>
            <IconWrapper>
              <div className="icon-rect blue">
                <img src={Globe3D} alt="Global Market" />
              </div>
            </IconWrapper>
            <ServiceText>
              <h2>Global Market Reach</h2>
              <p>
                Expand your business internationally with our established
                distribution channels and networks.
              </p>
            </ServiceText>
          </ServiceItem>

          {/* Service 3 */}
          <ServiceItem>
            <IconWrapper>
              <div className="icon-rect orange">
                <img src={Truck3D} alt="Logistics" />
              </div>
            </IconWrapper>
            <ServiceText>
              <h2>Reliable Logistics</h2>
              <p>
                Secure and efficient shipping solutions that ensure your
                products reach global markets on time.
              </p>
            </ServiceText>
          </ServiceItem>

          {/* Service 4 */}
          <ServiceItem reverse>
            <IconWrapper>
              <div className="icon-rect purple">
                <img src={Handshake3D} alt="Partnerships" />
              </div>
            </IconWrapper>
            <ServiceText>
              <h2>Supplier Partnerships</h2>
              <p>
                We build long-term partnerships with suppliers, creating mutual
                growth opportunities.
              </p>
            </ServiceText>
          </ServiceItem>
        </Container>
      </div>
    </Wrapper>
  );
}

/* ---------------- STYLES ---------------- */

const Wrapper = styled.section`
  width: 100%;
  padding: 10px 0; /* top/bottom spacing */
`;

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  height: auto;
`;

const HeaderInfo = styled.div`
  margin-bottom: 80px;
  text-align: center;

  h1 {
    font-size: 2.5rem;
    font-weight: 800;
    margin-bottom: 15px;
  }

  p {
    font-size: 1.1rem;
    color: #666;
    line-height: 1.7;
    max-width: 650px;
    margin: 0 auto;
  }
`;

const ServiceItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 80px;
  padding: 10px 0;
  flex-direction: ${(props) => (props.reverse ? "row-reverse" : "row")};
  cursor: pointer;
  overflow: visible !important; /* ✅ remove inner scrollbar */

  &:last-child {
    margin-bottom: 0;
  }

  &:hover .icon-rect {
    transform: scale(1.15) rotate(3deg);
    box-shadow: 0px 15px 35px rgba(0, 0, 0, 0.25);
  }

  &:hover h2 {
    opacity: 1;
    transform: translateY(0);
    color: #111;
  }

  &:hover p {
    opacity: 0.9;
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    margin-bottom: 80px;
  }
`;

const IconWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;

  .icon-rect {
    width: 180px;
    height: 140px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.5s ease;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    animation: float 4s ease-in-out infinite;
  }

  .icon-rect.green {
    background: linear-gradient(145deg, #a8f0c6, #4caf50);
  }
  .icon-rect.blue {
    background: linear-gradient(145deg, #a1d8ff, #2196f3);
  }
  .icon-rect.orange {
    background: linear-gradient(145deg, #ffd1a1, #ff9800);
  }
  .icon-rect.purple {
    background: linear-gradient(145deg, #d1a1ff, #9c27b0);
  }

  .icon-rect img {
    width: 100px;
    height: 100px;
    object-fit: contain;
    transition: transform 0.4s ease;
  }

  .icon-rect:hover img {
    transform: scale(1.2) rotate(-5deg);
  }

  @keyframes float {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-12px);
    }
    100% {
      transform: translateY(0px);
    }
  }

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

const ServiceText = styled.div`
  flex: 1;
  padding: 0 30px;

  h2 {
    font-size: 1.9rem;
    font-weight: 700;
    margin-bottom: 20px;
    color: #1b1b1b;
    opacity: 0.7;
    transform: translateY(10px);
    transition: all 0.5s ease;
  }

  p {
    font-size: 1.05rem;
    color: #444;
    line-height: 1.7;
    opacity: 0.6;
    transform: translateY(15px);
    transition: all 0.5s ease;
  }
`;
